<template>
  <div>
    <b-button v-b-modal.modal-prevent-closing>Додати тренера</b-button>
    <b-modal
      centered
      id="modal-prevent-closing"
      ref="modal"
      title="Створення тренера"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Ім'я"
          label-for="name-input"
          invalid-feedback="Додайте ім'я"
          :state="modalState"
        >
          <b-form-input
            :class="{
              'is-invalid': $v.trainer.name.$error && $v.trainer.name.$dirty,
            }"
            id="name-input"
            @blur="$v.trainer.name.$touch()"
            v-model="trainer.name"
            :state="modalState"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Призвіще"
          label-for="surname-input"
          invalid-feedback="Додайте призвіще!"
          :state="modalState"
        >
          <b-form-input
            @blur="$v.trainer.surname.$touch()"
            :class="{
              'is-invalid':
                $v.trainer.surname.$error && $v.trainer.surname.$dirty,
            }"
            id="name-input"
            v-model="trainer.surname"
            :state="modalState"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Дата народження"
          label-for="example-datepicker"
          invalid-feedback="Додайте дату народження"
          :state="modalState"
        >
          <b-form-datepicker
            :initial-date="'1990-5-1'"
            :show-decade-nav="true"
            :hide-header="true"
            :locale="'ru'"
            id="example-datepicker"
            v-model="trainer.birthday"
            class="mb-2"
          >
          </b-form-datepicker>
        </b-form-group>
        <b-form-group
          label="Тип тренера"
          label-for="type-input"
          invalid-feedback="Додайте тип!"
          :state="modalState"
        >
          <b-form-select
            @blur="$v.trainer.training_type.$touch()"
            :class="{
              'is-invalid':
                $v.trainer.training_type.$error && $v.training_type.$dirty,
            }"
            v-model="trainer.training_type"
            :options="options"
          >
            <template #first>
              <b-form-select-option :value="null" disabled
                >Оберіть тип тренування</b-form-select-option
              >
            </template>
          </b-form-select>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
var axios = require("axios");
import { required } from "vuelidate/lib/validators";

export default {
  name: "TrainerCreator",
  data: function () {
    return {
      trainer: {
        name: null,
        surname: null,
        birthday: null,
        training_type: null,
      },
      options: [
        { value: 1, text: "Персональний тренер" },
        { value: 2, text: "Груповий тренер" },
        { value: 3, text: "Масажист" },
        { value: 4, text: "Інші співробітники" },
      ],
      modalState: null,
    };
  },
  validations: {
    trainer: {
      name: {
        required,
      },
      surname: {
        required,
      },
      training_type: {
        required,
      },
    },
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid;
      return valid;
    },
    resetModal() {
      this.trainer = {};
      this.$v.$reset();
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      await axios
        .post(`${process.env.VUE_APP_API}/trainers/create`, this.trainer, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get("access_token")}`,
          },
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          }
        });
      this.$emit("refresh-trainers");
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });
    },
  },
};
</script>

<style scoped></style>
